<template>
  <div class="enterprise-list-page enterprise-list-page--beds">

    <!-- Header Card -->
        <PageHeader icon="fas fa-bed">
      <template #title>
        Daftar Bed {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola ketersediaan, status, dan kelas perawatan bed
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-if="manipulateBtn == true"
                @click="$router.push('/beds/add')">
                <i class="fas fa-plus"></i>
                <span>Tambah Bed</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>

            <!-- Filter -->
            <div class="row align-items-center justify-content-end mt-n3">
              <div class="col-md-3">
                <modern-search-input v-model="filter.name" fluid placeholder="Cari tempat tidur" @keyup="filterByName" />
              </div>
            </div>

            <medhop-data-table summary-title="Daftar Tempat Tidur"
              striped
              hover
              class="mt-3"
              :items="items"
              :fields="fields"
              responsive>
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '15%' : '' }" />
              </template>
              <template #cell(status)="data">
                <div v-if="data.item.status == 'Terpakai'">
                  <b-badge pill variant="primary">{{ data.item.status }}</b-badge>
                  <!-- <b-button
                    size="sm"
                    class="mr-1 btn-danger"
                  >{{data.item.status}}</b-button> -->
                </div>
                <div v-else-if="data.item.status == 'Tersedia'">
                  <b-badge pill variant="success">{{ data.item.status }}</b-badge>
                  <!-- <b-button
                    size="sm"
                    class="mr-1 btn-success"
                  >{{data.item.status}}</b-button> -->
                </div>
              </template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="$router.push({ path: '/beds/detail/' + data.item.id })"> <i class="fas fa-eye px-0"></i></b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Ubah"
                  v-if="manipulateBtn == true"
                  @click="$router.push({ path: '/beds/edit/' + data.item.id })"> <i class="fas fa-edit px-0"></i></b-button>
                <b-button
                  size="sm"
                  class="btn-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  v-if="manipulateBtn == true"
                  @click="deleteData(data.item.id)"> <i class="fas fa-trash px-0"></i></b-button>
              </template>
            </medhop-data-table>
            <b-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"></b-pagination>
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import module from "@/core/modules/CrudModule.js";
import { debouncer } from "@/core/modules/Helper.js"
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import Card from '@/view/content/Card.vue'

export default {

  name: 'List',

  components: {
    Card
  },

  data() {
    return {
      // Filter
      filter: {
        name: ''
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Fields
      fields: [
        {
          key: "number",
          label: '#',
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "bed_category_name",
          label: "Kategori Bed",
          sortable: true,
        },
        {
          key: "description",
          label: "Deskripsi",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Items
      items: [],
      manipulateBtn: false,
      clinic_name: "Medhop"

    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    filterByName() {
      debouncer(() => { this.pagination() }, 500)
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}`
      let response = await module.paginate('beds', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }
      this.items = response.data
    },

    async deleteData(id) {
      let result = await module.delete('beds/' + id)
      if (result) {
        this.list()
        this.$root.$emit('UpdateNewAvailableBed')
      }
    },

    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        

        if (access_right[a] == "1302") {
          this.manipulateBtn = true
        }

      }
    },

  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Bed" },
      { title: "Daftar Bed" },
    ])
    this.pagination()
    this.setActiveMenu()
    this.clinic_name = window.configuration == null ? "Medhop" : window.configuration.clinic_name
  },

}
</script>

<style></style>
